module.exports = __webpack_public_path__ + "img/th.4f861968.jpg";